import React from 'react';

import SameFinishPerformanceBanner from './SameFinishPerformanceBanner';
import { SameFinishPerformanceBannerData } from './SameFinishPerformanceBanner/models';

interface SameFinishPerformanceBannerPropsRaw {
  bgImageMobile?: { url: string };
  bgImageDesktop?: { url: string };
  bgTearPaperMobile: { url: string };
  bgTearPaperDesktop: { url: string };
  finishLogo?: { url: string };
  headingTitle?: string;
  headingSubtitle?: string;
  fgImageMobile?: { url: string };
  fgImageDesktop?: { url: string };
}

const SameFinishPerformanceBannerWrapper = (props: SameFinishPerformanceBannerPropsRaw) => {
  const {
    bgImageMobile,
    bgImageDesktop,
    bgTearPaperMobile,
    bgTearPaperDesktop,
    finishLogo,
    headingTitle,
    headingSubtitle,
    fgImageMobile,
    fgImageDesktop,
  } = props;

  const data: SameFinishPerformanceBannerData = {
    bgImageDesktop,
    bgImageMobile,
    bgTearPaperMobile,
    bgTearPaperDesktop,
    finishLogo,
    headingTitle,
    headingSubtitle,
    fgImageMobile,
    fgImageDesktop,
  };

  return <SameFinishPerformanceBanner data={data} />;
};

SameFinishPerformanceBannerWrapper.displayName = 'SameFinishPerformanceBannerWrapper';
export default SameFinishPerformanceBannerWrapper;
